import { useMemo } from 'react';

import { useQuery } from '@mint-lib/query-client';

import { toFolderNode } from '../../helpers/knowledge-base/fileSystemNode.js';
import { getFolderOption } from '../../queries/knowledgeBase.js';
import { ROOT_FOLDER_ID } from '../../types/fileSystem.js';

const useCurrentFolder = (folderId: string) => {
  const { data, isLoading } = useQuery({
    ...getFolderOption(folderId),
    enabled: !!folderId && folderId !== ROOT_FOLDER_ID,
  });

  const folderFormat = useMemo(() => {
    return data ? toFolderNode(data, ROOT_FOLDER_ID) : undefined;
  }, [data]);

  return { data, folderFormat, isLoading };
};

export { useCurrentFolder };
